import { render, staticRenderFns } from "./promo-sale-reminder-modal.vue?vue&type=template&id=eebdab30&scoped=true&"
import script from "./promo-sale-reminder-modal.vue?vue&type=script&lang=js&"
export * from "./promo-sale-reminder-modal.vue?vue&type=script&lang=js&"
import style0 from "./promo-sale-reminder-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./promo-sale-reminder-modal.vue?vue&type=style&index=1&id=eebdab30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebdab30",
  null
  
)

export default component.exports